
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://axkwrnkqyuegftszrwne.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF4a3dybmtxeXVlZ2Z0c3pyd25lIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzk3Nzk1MzYsImV4cCI6MjA1NTM1NTUzNn0.dhcAGDl3HIMAw1Oupgi5_kgqkNKcJwyxUjuQuOHjVAc";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storage: localStorage,
    storageKey: 'turnles-planner-auth',
    flowType: 'pkce',
    debug: true // Enable this temporarily to help troubleshoot authentication issues
  },
  realtime: {
    params: {
      eventsPerSecond: 2
    }
  },
  db: {
    schema: 'public'
  }
});

// Add custom types for the new RPC function
declare module '@supabase/supabase-js' {
  interface SupabaseClient<Database> {
    rpc<Response>(
      fn: 'activate_floor_plan' | 'get_secret' | 'is_admin' | 'is_admin_secure' | 'is_tp_user_secure',
      params?: object,
      options?: {}
    ): { data: Response; error: Error };
  }
}
